import React from 'react';
import {
  FormTemplateQuestionFieldOptionGroupEnum,
  FormTemplateQuestionFieldsKindEnum,
} from 'graphql-common';
import RadioButtonGroup, {
  RadioButtonWrapViews,
} from '@lib/components/RadioButtonGroup/RadioButtonGroup';
import RadioButtonAsButton from '@lib/components/RadioButtonAsButton/RadioButtonAsButton';
import { ComponentProps, defaultProps } from '../types';

export default function YesNoPreview({ options }: ComponentProps) {
  const preparedOptions = options.map(({ group, values }) => ({
    value: group || '',
    label: values[0] || '',
    leftIcon:
      group === FormTemplateQuestionFieldOptionGroupEnum.Yes
        ? 'check_circle'
        : 'cancel',
  }));
  return (
    <RadioButtonGroup
      options={preparedOptions}
      value={undefined}
      name={FormTemplateQuestionFieldsKindEnum.RadioButton}
      RadioButtonComponent={RadioButtonAsButton}
      radioButtonComponentProps={{
        disabled: true,
        fullWidth: true,
      }}
      wrapView={RadioButtonWrapViews.list}
      {...defaultProps}
    />
  );
}
